import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { CategoryComponent } from './category/category.component';
import { HomeComponent } from './home/home.component';
import { PoiDetailComponent } from './poi/poi-detail/poi-detail.component';
import { MunicipalityComponent } from './municipality/municipality.component';
import { AppdownloadComponent } from './appdownload/appdownload.component';
import { ImpressumComponent } from './impressum/impressum.component';
import { DatenschutzComponent } from './datenschutz/datenschutz.component';
import { AccommodationsComponent } from './accommodations/accommodations.component';


const routes: Routes = [ 
  { path: 'gemeinde/:municipality', component: MunicipalityComponent },
  { path: 'app', component: AppdownloadComponent },
  { path: 'datenschutz', component: DatenschutzComponent },
  { path: 'impressum', component: ImpressumComponent },
  { path: 'unterkuenfte', component: AccommodationsComponent },
  { path: ':category', component: CategoryComponent },
  { path: ':category/:id', component: PoiDetailComponent },
  { path: '', component: HomeComponent },
  { path: '**', redirectTo: ''}
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    initialNavigation: 'enabled'
})],
  exports: [RouterModule]
})
export class AppRoutingModule { }
